<template>
    <div class="container">
        <order-list :orders="voidedOrders"></order-list>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        name: 'voided-orders',
        data() {
            return {}
        },
        computed: Object.assign({}, mapGetters(['voidedOrders'])),
    };
</script>



// WEBPACK FOOTER //
// VoidedOrders.vue?05ebcd45